import { useEffect, useState } from 'react';
import client from '../lib/sanityClient';

const SEO = () => {
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const path = window.location?.pathname;

    if (seoData && seoData?.pageName === path) return;

    client?.fetch('*[_type == "seoMeta" && pageName == $path][0]', { path })?.then((data) => {
        console.log('Sanity SEO Data:', data);
        setSeoData(data);
      })?.catch((err) => {
        console.warn('[SEO] Fetch error:', err);
      });
  }, []);

  useEffect(() => {
    if (!seoData) return;

    const applyTags = () => {
      if (seoData?.metaTitle && document.title !== seoData?.metaTitle) {
        document.title = seoData?.metaTitle;
      }

      const updateMeta = (selector, content) => {
        if (!content) return;
        let el = document.querySelector(selector);
        if (!el) {
          el = document.createElement('meta');
          if (selector?.includes('name=')) el.name = selector?.match(/name="([^"]+)"/)?.[1];
          if (selector?.includes('property=')) el?.setAttribute('property', selector?.match(/property="([^"]+)"/)?.[1]);
          document.head?.appendChild(el);
        }
        if (el?.content !== content) el.content = content;
      };

      updateMeta('meta[name="description"]', seoData?.metaDescription);
      updateMeta('meta[property="og:title"]', seoData?.ogTitle || seoData?.metaTitle);
      updateMeta('meta[property="og:description"]', seoData?.ogDescription || seoData?.metaDescription);
      updateMeta('meta[property="twitter:title"]', seoData?.ogTitle || seoData?.metaTitle);
      updateMeta('meta[property="twitter:description"]', seoData?.ogDescription || seoData?.metaDescription);
    };

    // Run immediately
    applyTags();

    // Stand guard and force tags to stay if React tries to overwrite them
    const observer = new MutationObserver(applyTags);
    observer?.observe(document.head, { childList: true, subtree: true, attributes: true });

    return () => observer?.disconnect();
  }, [seoData]);

  return null;
};

export default SEO;